import Visibility from "@mapmycustomers/shared/enum/Visibility";
import PinLegend from "@mapmycustomers/shared/types/map/PinLegend";
import User from "@mapmycustomers/shared/types/User";

const canEditPinLegend = (pinLegend: PinLegend, currentUserId: User["id"], isOwner?: boolean) =>
  // legend is EDITABLE (do not mess with VISIBLE) when...
  // ... it is not default AND
  !pinLegend.default &&
  // ...it is private or legend creator is current user or they are owner
  (pinLegend.visibility === Visibility.PRIVATE || pinLegend.user.id === currentUserId || isOwner);

export default canEditPinLegend;
